module.exports = __webpack_public_path__ + "static/media/texture_04.89cfc108.png";